import { Divider } from '@/components/base/divider'
import { Overview } from './overview'
import { Table } from '@/components/maintenance_event/table'
import { Calendar } from './calendar'
import { MaintenanceEventState } from '@/types'

export const Index = () => {
  return (
    <>
      <div className="flex flex-col gap-12">
        <Overview />
        <Divider />
        <Calendar />
        <Divider />
        <Table
          filters={{ stateNotEq: MaintenanceEventState.Completed }}
          hiddenColumns={['State']}
          pageSize={10}
          title="Overdue maintenance"
          fixedHeight
        />
      </div>
    </>
  )
}
